import React from 'react'
import { Banner } from '../Components/Banner'
import { Header } from '../Components/Header'
import { Tours } from '../Components/Tours'
import { Footer} from '../Components/Footer'

export const Home = () => {
  return (
    <React.Fragment>
        <Header/>
        <Tours/>
        <Footer />
    </React.Fragment>
   
  )
}
